export const mockOrders = [
  {
    id: "SKT-2024-001",
    userId: "demo@skinnthrive.com",
    status: "delivered",
    createdAt: "2024-12-10T09:30:00Z",
    updatedAt: "2024-12-14T16:00:00Z",
    items: [
      { productId: 2, title: "Cetaphil Gentle Skin Cleanser 500ml", price: 699, quantity: 1, image: "https://images.unsplash.com/photo-1608248543803-ba4f8c70ae0b?w=100&q=80" },
      { productId: 5, title: "Bioderma Photoderm MAX SPF50+", price: 749, quantity: 2, image: "https://images.unsplash.com/photo-1521590832167-7bcbfaa6381f?w=100&q=80" },
    ],
    subtotal: 2197,
    discount: 0,
    shipping: 80,
    total: 2277,
    couponCode: null,
    paymentMethod: "COD",
    paymentStatus: "paid",
    address: {
      name: "Priya Sharma",
      phone: "9876543210",
      line1: "Flat 4B, Sunshine Apartments",
      line2: "MG Road",
      city: "Bengaluru",
      state: "Karnataka",
      pincode: "560001",
    },
    tracking: {
      carrier: "Shiprocket",
      trackingId: "SR123456789",
      status: "Delivered",
      estimatedDelivery: "2024-12-14",
      events: [
        { date: "2024-12-10", time: "10:00", status: "Order Placed", location: "Online" },
        { date: "2024-12-10", time: "14:00", status: "Order Confirmed", location: "Warehouse" },
        { date: "2024-12-11", time: "09:00", status: "Shipped", location: "Mumbai Hub" },
        { date: "2024-12-13", time: "11:30", status: "Out for Delivery", location: "Bengaluru" },
        { date: "2024-12-14", time: "15:45", status: "Delivered", location: "Bengaluru" },
      ],
    },
  },
  {
    id: "SKT-2024-002",
    userId: "demo@skinnthrive.com",
    status: "shipped",
    createdAt: "2024-12-18T14:00:00Z",
    updatedAt: "2024-12-19T10:00:00Z",
    items: [
      { productId: 3, title: "CeraVe Moisturizing Cream 177ml", price: 849, quantity: 1, image: "https://images.unsplash.com/photo-1611080626919-7cf5a9dbab12?w=100&q=80" },
      { productId: 15, title: "CeraVe Vitamin C Serum 30ml", price: 1299, quantity: 1, image: "https://images.unsplash.com/photo-1596462502278-27bfdc403348?w=100&q=80" },
    ],
    subtotal: 2148,
    discount: 214.8,
    shipping: 0,
    total: 1933.2,
    couponCode: "SAVE10",
    paymentMethod: "Prepaid",
    paymentStatus: "paid",
    address: {
      name: "Priya Sharma",
      phone: "9876543210",
      line1: "Flat 4B, Sunshine Apartments",
      line2: "MG Road",
      city: "Bengaluru",
      state: "Karnataka",
      pincode: "560001",
    },
    tracking: {
      carrier: "Shiprocket",
      trackingId: "SR987654321",
      status: "In Transit",
      estimatedDelivery: "2024-12-22",
      events: [
        { date: "2024-12-18", time: "15:00", status: "Order Placed", location: "Online" },
        { date: "2024-12-18", time: "18:00", status: "Order Confirmed", location: "Warehouse" },
        { date: "2024-12-19", time: "10:00", status: "Shipped", location: "Mumbai Hub" },
      ],
    },
  },
  {
    id: "SKT-2024-003",
    userId: "demo@skinnthrive.com",
    status: "processing",
    createdAt: "2024-12-20T11:00:00Z",
    updatedAt: "2024-12-20T11:00:00Z",
    items: [
      { productId: 18, title: "Sesderma Kojicol Plus Brightening Serum 30ml", price: 2199, quantity: 1, image: "https://images.unsplash.com/photo-1596462502278-27bfdc403348?w=100&q=80" },
    ],
    subtotal: 2199,
    discount: 0,
    shipping: 80,
    total: 2279,
    couponCode: null,
    paymentMethod: "COD",
    paymentStatus: "pending",
    address: {
      name: "Priya Sharma",
      phone: "9876543210",
      line1: "Flat 4B, Sunshine Apartments",
      line2: "MG Road",
      city: "Bengaluru",
      state: "Karnataka",
      pincode: "560001",
    },
    tracking: {
      carrier: "Shiprocket",
      trackingId: null,
      status: "Processing",
      estimatedDelivery: "2024-12-26",
      events: [
        { date: "2024-12-20", time: "11:00", status: "Order Placed", location: "Online" },
        { date: "2024-12-20", time: "12:00", status: "Order Confirmed", location: "Warehouse" },
      ],
    },
  },
];

export const promoCodes = [
  { code: "SAVE10", discount: 10, type: "percentage", minOrder: 500, description: "10% off on orders above ₹500" },
  { code: "FIRST15", discount: 15, type: "percentage", minOrder: 0, description: "15% off on your first order" },
  { code: "FLAT50", discount: 50, type: "flat", minOrder: 799, description: "₹50 off on orders above ₹799" },
  { code: "PREPAID80", discount: 80, type: "flat", minOrder: 699, description: "₹80 off on prepaid orders above ₹699" },
  { code: "SKIN20", discount: 20, type: "percentage", minOrder: 1000, description: "20% off on orders above ₹1000" },
];

export const validatePromoCode = (code, orderTotal) => {
  const promo = promoCodes.find(p => p.code === code.toUpperCase());
  if (!promo) return { valid: false, message: "Invalid promo code" };
  if (orderTotal < promo.minOrder) return { valid: false, message: `Minimum order of ₹${promo.minOrder} required` };
  const discountAmount = promo.type === 'percentage' ? (orderTotal * promo.discount / 100) : promo.discount;
  return { valid: true, promo, discountAmount, message: promo.description };
};
